/**
 * 
 */
define([], function() {	
	
	"use strict";
	
	var sogicaReferral = {
			 init : function(){
				var sogica = document.getElementById('sogicaUrl');
				if(typeof sogica !== undefined && sogica!=null){
				    var sogicaURL = document.getElementById('sogicaUrl').value;
				    let iframeEl = document.getElementById('raf-form');
				    iframeEl.setAttribute('referrerpolicy', 'origin');
				    iframeEl.setAttribute('data-raf-origin', sogicaURL);
			 	}
			    let formEl =document.getElementById('raf-data');
			    if(formEl != null){
			    	formEl.setAttribute('action', sogicaURL);
			    	formEl.setAttribute('enctype', 'application/x-www-form-urlencoded');
			    }
			    var rafFrameEl = document.getElementById('raf-form');
			    if (rafFrameEl != null) {
			        const remoteUrl = new URL(document.getElementById('raf-data').action);
			        const raffFrameOrigin = remoteUrl.origin;
			        const oldRaffFrameOrigin = rafFrameEl.getAttribute('data-raf-origin');
			       
			        rafFrameEl.addEventListener('load', function () {
			           COSTCO.sogicaReferral.registerRafFormIframe('raf-form', raffFrameOrigin);
			        });
			        document.forms['raf-data'].submit();
			    }

			 },

			  registerRafFormIframe : function (id, other_domain) {
			        var iframe = document.getElementById(id);
			        // add an event listener for cross frame messages
			        window.addEventListener('message', function (event) {
			        if (event.origin !== other_domain) {
			              console.log('dropped message because origin was incorrect.');
			              return;
			            }
			        try {
			            if (event.data.action == 'continue-shopping') {
			            	COSTCO.sogicaReferral.continueShopping();
			                return;
			            }
			            if (event.data.action == 'resize') {
			                let height = parseInt(event.data.height) + 40; // add some padding to prevent scrollbars
			                console.log(`setting frame height to '${height}'`);
			                iframe.setAttribute('height', height);
			                return;
			            }
			            } catch (e) {
			                console.error(e);
			            }

			        }, { once: false, passive: true });
			  },
			  continueShopping : function() {
					if (document.referrer.indexOf('costco.') > -1) {
						window.location = COSTCO.util.scrubSpecialChars(document.referrer);
					}
					else {
						window.location = '/';
					}
				}
			
		}
	
	   if (typeof window.COSTCO === "undefined") {
	        window.COSTCO = new Object();
	    } 
	    window.COSTCO.sogicaReferral = sogicaReferral;
		return sogicaReferral;
});


// WEBPACK FOOTER //
// ./js/browse/sogicaReferral.js